import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_RBB_CANCEL_PURCH_MODAL_HEADER]: 'Cancel Your Digital Order',
  [StringId.DV_RBB_CANCEL_PURCH_MODAL_SUBMIT]: 'Cancel Order',
  [StringId.DV_AB_CANCEL_ACCIDENTAL_PURCHASE]: 'Purchased by accident? {link|cancelLink}Cancel your order{end}',
  [StringId.DV_DP_you_multiple_orders_for_this_title]: 'You have multiple orders associated with this title.',
  [StringId.DV_DP_choose_order_to_cancel]: 'Choose an order to cancel:'

}
